import { useState, useRef, useEffect } from "react";
import Topbar from "../../components/Topbar/Topbar";
import { dummyimage, maintanence } from "../../assets/img";
import CloudUploadRoundedIcon from "@mui/icons-material/CloudUploadRounded";
import { URLS } from "../../Services/Constant";
import { get, put } from "../../Services/ApiHandler";
import { toast } from "react-toastify";
import moment from "moment";
import { checkPermission } from "../redux/api/PermissionManager";

const Maintanence = () => {
  const [formData, setFormData] = useState({
    image: null,
    reason: "",
    fromDate: "",
    fromTime: "",
    toDate: "",
    toTime: "",
    imageUrl: "",
    type: "",
  });

  const today = moment().format("YYYY-MM-DD");

  const [errors, setErrors] = useState({});
  const [imagePreview, setImagePreview] = useState(null);
  const [show, setShow] = useState(false);

  const fileInputRef = useRef(null);

  const fetchData = async () => {
    try {
      const res = await get(URLS.VOW_VERSION_LIST);
      if (res?.status === "success") {
        let data = res?.data[0];

        const active = maintanceActive(
          data.maintenance_start_at,
          data.maintenance_end_at,
        );
        setShow(active);

        const startDate = data?.maintenance_start_at
          ? new Date(data.maintenance_start_at)
          : null;
        const endDate = data?.maintenance_end_at
          ? new Date(data.maintenance_end_at)
          : null;

        setFormData((prev) => ({
          ...prev,
          reason: data?.setting_value || "",
          fromDate: startDate ? startDate.toISOString().split("T")[0] : "",
          fromTime: startDate ? startDate.toTimeString().substring(0, 5) : "",
          toDate: endDate ? endDate.toISOString().split("T")[0] : "",
          toTime: endDate ? endDate.toTimeString().substring(0, 5) : "",
          imageUrl: data?.image || "",
          type: data?.id || "",
        }));

        if (data?.image) {
          setImagePreview(data.image);
        }
      }
    } catch (error) {
      console.error("Error fetching maintenance data:", error);
    } finally {
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      if (formData.fromDate && formData.toDate) {
        const start = `${formData.fromDate}T${formData.fromTime}:00`;
        const end = `${formData.toDate}T${formData.toTime}:00`;

        setShow(maintanceActive(start, end));
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [formData.fromDate, formData.fromTime, formData.toDate, formData.toTime]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "image" && files && files[0]) {
      const file = files[0];
      setFormData((prev) => ({
        ...prev,
        image: file,
        imageUrl: "",
      }));

      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  const handleRemoveImage = () => {
    setFormData((prev) => ({
      ...prev,
      image: null,
      imageUrl: "",
    }));
    setImagePreview(null);

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleCancel = () => {
    fetchData();
  };

  const handleSubmit = async () => {
    const newErrors = {};
    if (!formData.reason.trim()) {
      newErrors.reason = "Maintenance reason is required";
    }
    if (!formData.fromDate) {
      newErrors.fromDate = "Start date is required";
    }
    if (!formData.fromTime) {
      newErrors.fromTime = "Start time is required";
    }
    if (!formData.toDate) {
      newErrors.toDate = "End date is required";
    }
    if (!formData.toTime) {
      newErrors.toTime = "End time is required";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    const submitData = new FormData();
    submitData.append("type", 4);
    submitData.append("setting_value", formData.reason);

    const startDateTime = `${formData.fromDate}T${formData.fromTime}:00`;
    const endDateTime = `${formData.toDate}T${formData.toTime}:00`;

    submitData.append("maintenance_start_at", startDateTime);
    submitData.append("maintenance_end_at", endDateTime);

    if (formData.image) {
      submitData.append("image", formData.image);
    }
    for (let pair of submitData.entries()) {
      console.log(pair[0] + ": ", pair[1]);
    }
    // return;
    let url = `${URLS.MAINTANENCE_CREATE}/${formData.type}/update/`;

    let res = await put(url, submitData);
    console.log("res", res);
    if (res?.status == "success") {
      toast.success(res?.message);
      fetchData();
    }
  };

  const maintanceActive = (start, end) => {
    if (!start || !end) return false;

    const now = moment();
    return now.isSameOrAfter(moment(start)) && now.isSameOrBefore(moment(end));
  };

  return (
    <div>
      <Topbar header="Vow Settings" />

      <div className="d-flex ac-jb mb-4">
        <h2 className="f2 fs-sm-16 fs-md-18 fs-lg-20 fs-xl-22 fs-xxl-24 my-4">
          Maintenance
        </h2>
        {show && (
          <img
            src={maintanence}
            style={{ height: "50px", width: "200px", objectFit: "contain" }}
          />
        )}
      </div>
      <div className="d-flex flex-wrap gap-5">
        <div className="d-flex flex-column as-jc position-relative col-md-12">
          {imagePreview ? (
            <div className="position-relative">
              <img
                src={imagePreview}
                style={{
                  width: "500px",
                  height: "300px",
                  objectFit: "cover",
                  borderRadius: "8px",
                  border: "2px solid #ddd",
                }}
                alt="Maintenance Preview"
              />
              <button
                type="button"
                onClick={handleRemoveImage}
                style={{
                  position: "absolute",
                  top: "-10px",
                  right: "-10px",
                  background: "#ff4444",
                  color: "white",
                  border: "none",
                  borderRadius: "50%",
                  width: "25px",
                  height: "25px",
                  cursor: "pointer",
                  fontSize: "12px",
                }}
                disabled={!checkPermission("CAN-EDIT-MAINTENANCE")}
              >
                ×
              </button>
            </div>
          ) : (
            <img
              src={dummyimage}
              style={{
                width: "500px",
                height: "300px",
                objectFit: "contain",
                borderRadius: "8px",
                border: "2px dashed #ddd",
              }}
              alt="Placeholder"
            />
          )}

          <button
            type="button"
            className="submit-btn my-3"
            onClick={handleUploadClick}
            disabled={!checkPermission("CAN-EDIT-MAINTENANCE")}
          >
            <CloudUploadRoundedIcon className="me-2" mb-1 />
            {formData.image || formData.imageUrl ? "Change Image" : "Upload"}
          </button>

          <input
            ref={fileInputRef}
            type="file"
            className="input-pop mt-2 w-100 d-none"
            accept="image/*"
            name="image"
            onChange={!checkPermission("CAN-EDIT-MAINTENANCE") && handleChange}
          />
          {errors?.image && <p className="err">{errors.image}</p>}

          {formData.image && (
            <p className="f3 mt-2">Selected: {formData.image.name}</p>
          )}
          {formData.imageUrl && !formData.image && (
            <p className="f3 mt-2">Current image from server</p>
          )}
        </div>

        <div className="col-md-5">
          <p className="f3 mb-1">Maintenance Reason</p>
          <textarea
            className="input-box"
            name="reason"
            value={formData.reason}
            onChange={handleChange}
            placeholder="Enter Maintenance Reason"
            rows={5}
            disabled={!checkPermission("CAN-EDIT-MAINTENANCE")}
          />
          {errors.reason && <p className="err">{errors.reason}</p>}
        </div>

        <div className="d-flex gap-5 col-md-12">
          <div className="col-md-3">
            <label className="f3 mb-1">Start Date</label>
            <input
              type="date"
              name="fromDate"
              value={formData.fromDate}
              onChange={handleChange}
              className="input-box"
              min={today}
              disabled={!checkPermission("CAN-EDIT-MAINTENANCE")}
            />
            {errors.fromDate && <p className="err">{errors.fromDate}</p>}
          </div>
          <div className="col-md-3">
            <label className="f3 mb-1">Start Time</label>
            <input
              type="time"
              name="fromTime"
              value={formData.fromTime}
              onChange={handleChange}
              className="input-box"
              disabled={!checkPermission("CAN-EDIT-MAINTENANCE")}
            />
            {errors.fromTime && <p className="err">{errors.fromTime}</p>}
          </div>
        </div>

        <div className="d-flex gap-5 col-md-12">
          <div className="col-md-3">
            <label className="f3 mb-1">End Date</label>
            <input
              type="date"
              name="toDate"
              value={formData.toDate}
              onChange={handleChange}
              className="input-box"
              min={today}
              disabled={!checkPermission("CAN-EDIT-MAINTENANCE")}
            />
            {errors.toDate && <p className="err">{errors.toDate}</p>}
          </div>
          <div className="col-md-3">
            <label className="f3 mb-1">End Time</label>
            <input
              type="time"
              name="toTime"
              value={formData.toTime}
              onChange={handleChange}
              className="input-box"
              disabled={!checkPermission("CAN-EDIT-MAINTENANCE")}
            />
            {errors.toTime && <p className="err">{errors.toTime}</p>}
          </div>
        </div>
      </div>

      <div className="d-flex ac-jb mt-5">
        {checkPermission("CAN-EDIT-MAINTENANCE") && (
          <>
            <button className="back-btn mt-3" onClick={handleCancel}>
              Cancel
            </button>
            <button className="submit-btn mt-3" onClick={handleSubmit}>
              Confirm
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default Maintanence;
